// extracted by mini-css-extract-plugin
export default {"titleBlock":"FamilyFolderModal__titleBlock--snfW_","title":"FamilyFolderModal__title--Igdt2","description":"FamilyFolderModal__description--1ARVC"};